import { PERIODS } from "./FilterBar";

const VALID_PERIOD_KEYS = new Set(PERIODS.map((p) => p.key));
const DEFAULT_PERIOD = "monthly";

// yyyy-mm-dd, matches the <input type="date"> format used by FilterBar.
const isValidDateString = (value) => /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(new Date(value).getTime());

// Reads { period, customRange } out of the current URL's query string.
// Never trusts the URL blindly -- an unknown/garbage `period` or a malformed
// date falls back to the default rather than being passed downstream.
export function readFiltersFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const from = params.get("from");
    const to = params.get("to");

    if ((from && isValidDateString(from)) || (to && isValidDateString(to))) {
        return {
            period: DEFAULT_PERIOD,
            customRange: {
                from: from && isValidDateString(from) ? from : "",
                to: to && isValidDateString(to) ? to : "",
            },
        };
    }

    const period = params.get("period");
    return {
        period: period && VALID_PERIOD_KEYS.has(period) ? period : DEFAULT_PERIOD,
        customRange: { from: "", to: "" },
    };
}

// Writes the current filter selection back into the URL (replacing history,
// not pushing a new entry) so a refresh restores the same view. Only one of
// period / from+to is ever present at a time, mirroring isCustomRange.
export function writeFiltersToUrl({ period, customRange }) {
    const params = new URLSearchParams(window.location.search);
    const isCustomRange = !!(customRange?.from || customRange?.to);

    params.delete("period");
    params.delete("from");
    params.delete("to");

    if (isCustomRange) {
        if (customRange.from) params.set("from", customRange.from);
        if (customRange.to) params.set("to", customRange.to);
    } else {
        params.set("period", period || DEFAULT_PERIOD);
    }

    const query = params.toString();
    const newUrl = `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`;
    window.history.replaceState(window.history.state, "", newUrl);
}